export enum Permission {
    ADDRESSES = 'addresses',
    CONTACT_INFO = 'contactInfo',
    EBANKING_CONTRACTS = 'contracts',
    ORDERS = 'orders',
    ORDER_CLIENT_RELATION = 'ordersClientRelation',
    PERSONAL_DATA = 'personalData',
    POPUPS = 'popups',
    POWER_OF_ATTORNEY = 'powerOfAttorney',
    PRODUCTS = 'products',
    SEND_MESSAGE = 'sendMessage',
    UPLOAD_DOCUMENT = 'uploadDocument',
}
